import { FC, PropsWithChildren, useMemo } from 'react';

import HealthStatusContext from '@/context/HealthStatusContext/HealthStatusContext';
import useGetApiHealth from '@/hooks/api/health/useGetApiHealth';
import useGetIdpHealth from '@/hooks/api/health/useGetIdpHealth';

const HealthStatusContextProvider: FC<PropsWithChildren<unknown>> = ({
  children,
}) => {
  const { Provider } = HealthStatusContext;
  const { isApiAvailable, isPending: isApiHealthLoading } = useGetApiHealth();
  const { isIdpAvailable, isPending: isIdpHealthLoading } = useGetIdpHealth();
  const isPending = isApiHealthLoading || isIdpHealthLoading;

  const areSystemsAvailable: boolean = useMemo(() => {
    if (isPending) {
      return false;
    }

    return isApiAvailable && isIdpAvailable;
  }, [isPending, isApiAvailable, isIdpAvailable]);

  return (
    <Provider value={{ areSystemsAvailable, isPending }}>{children}</Provider>
  );
};

export default HealthStatusContextProvider;
